import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AuthState, LoginResponse, User } from '../../types/auth';
import { getStoredAuthData, setAuthData, clearAuthData } from '../../utils/storage';

// Initialize state from localStorage
const initialState: AuthState = getStoredAuthData();

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action: PayloadAction<LoginResponse>) => {
            const authData = {
                user: action.payload.user,
                accessToken: action.payload.accessToken,
                refreshToken: action.payload.refreshToken,
                permissions: action.payload.permissions,
                org_id: action.payload.org_id || action.payload.user?.org_id,
                patient_id: action.payload.patient_id || action.payload.user?.patient_id
            };

            // Update localStorage
            setAuthData(authData);

            // Update state
            state.user = authData.user;
            state.token = authData.accessToken;
            state.refreshToken = authData.refreshToken;
            state.permissions = authData.permissions;
            state.org_id = authData.org_id;
            state.patient_id = authData.patient_id;
            state.isAuthenticated = true;
        },
        logout: (state) => {
            // Clear localStorage
            clearAuthData();

            // Clear state
            state.user = null;
            state.token = null;
            state.refreshToken = null;
            state.permissions = null;
            state.org_id = null;
            state.patient_id = null;
            state.isAuthenticated = false;
        },
    },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;

// Selectors
export const selectCurrentUser = (state: { auth: AuthState }) => state.auth.user;
export const selectIsAuthenticated = (state: { auth: AuthState }) => state.auth.isAuthenticated;
export const selectToken = (state: { auth: AuthState }) => state.auth.token;